// Translations Utils class for core components, this will read out the active lang from session.
// Temporary touch to trigger Storybook CI validation on this PR branch.
// to set up in a consumer (Pathway/Relay/Nucleus) then in the transloco root module getTranslation()
// it would need to save to session once its worked out the active lang:
//
// Example code in Pathway getTranslation transloco-root.module:
//
// async getTranslation(lang: string) {
//     const data = await new TranslocoHttpLoader(this.http, environment.translationPath).getTranslation(lang, 'pathway');
//     if (data) {
//       // save off the active i18ns to session storage, so we can then consume in core components
//       sessionStorage.setItem(`activeI18ns`, JSON.stringify(data));
//     }
//     return data;
//   }

export class TranslationUtils {
  static _instance: TranslationUtils;
  private _translations = null;

  private constructor() {
    this.fetch();
  }

  public static get instance(): TranslationUtils {
    if (!TranslationUtils._instance) {
      TranslationUtils._instance = new TranslationUtils();
    }
    return TranslationUtils._instance;
  }

  private fetch() {
    this._translations = JSON.parse(sessionStorage.getItem('activeI18ns'));
    if (this._translations) {
      return this._translations;
    } else {
      console.log('Could not find core component active i18ns in session');
    }
  }

  public translate(key: string, fallback: string) {
    if (!this._translations) {
      return fallback;
    }

    if (key.indexOf('.') === -1) {
      return this._translations[key] ?? fallback;
    } else {
      // resolve nested translation
      const keys = key.split('.');
      return keys.reduce((previousValue: string, currentValue: string) => {
        if (!previousValue[currentValue]) {
          return fallback;
        }
        return previousValue[currentValue];
      }, this._translations);
    }
  }
}
